import { InjectionToken } from '@angular/core';
import { NativeSettings } from 'capacitor-native-settings';
import type { NativeSettingsPlugin } from 'capacitor-native-settings';

export const NATIVE_SETTINGS_TOKEN = new InjectionToken<NativeSettingsPlugin>('NativeSettings');

export function provideNativeSettings() {
  return {
    provide: NATIVE_SETTINGS_TOKEN,
    useValue: NativeSettings,
  };
}
